<section>

  <div id="snackbar"></div>
  <!-- <h1 class="page-title">{{ 'ICO Information' | translate}}</h1> -->
  <div class="background">


    <div class="head-section">
      <div class="page-title d-flex content-flex">
        <span class="img-borders"> <img src="../../../assets/img/PIPTLE-ILO-sideicon.png" class="sidebar-img" alt="">
        </span>
        <h1 class="page-title text-left">
          {{ 'ICO Tracker' | translate}}
        </h1>
      </div>
      <div class="clearfix ico-top-divs row">
        <div class="col-sm-6 col-md-4 col-lg-3 no-right">
          <div class="inner-box ">


            <div class="top-left-ico-text">
              <p class="ico-top-text">CURRENT STAGE PIP ISSUE:
                <!-- <span class="white-right">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                    <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                  </svg>
                </span> -->
              </p>
            </div>


            <div class="clearfix table-type">


              <div class="left-stat-icon">

                <img src="../../../assets/img/left-cash-icon.png">


              </div>

              <div class="right-icon-stats">


                <p class="number">
                  <!-- {{ICOInformation?.Sale}} -->
                  <!-- {{ICOStageInfoLeft?.amountSold | currency: 'crypto'}} -->
                  {{currentStagePPTL}}

                  <span class="dollar">PIP</span>
                </p>
                <p class="total-text">{{ 'ISSUED VALUE ' | translate}}</p>


              </div>


            </div>




          </div>
        </div>
        <!-- <div class="col-sm-6 col-md-4 col-lg-3 no-right">
          <div class="inner-box ">



            <div class="top-left-ico-text">
              <p class="ico-top-text"> NEW PARTICIPATING LICENSEES
                svg commented before as well
                <span class="white-right">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                    <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                  </svg>
                </span>
              </p>
            </div>

            <div class="clearfix table-type">


              <div class="left-stat-icon">

                <img src="../../../assets/img/globe.png" width="100">


              </div>

              <div class="right-icon-stats">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <p class="number pt-0">{{globalInfo?.total_gpa_licences}}

                    </p>
                    <p class="total-text ml-2">GPA Licensees
                    </p>
                  </div>
                  <div class="d-flex align-items-center mt-2">
                    <p class="number pt-0">{{globalInfo?.other_licences}}
                    </p>
                    <p class="total-text ml-2">Other Licensees
                    </p>
                  </div>
                </div>
              </div>


            </div>





          </div>
        </div> -->
        <div class="col-sm-12 col-md-4 col-lg-3 no-right">
          <div class="inner-box">
            <div class="top-left-ico-text">
              <p class="ico-top-text">TOTAL REGISTRANT COUNTRIES
                <!-- <span class="white-right">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                    <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                  </svg>
                </span> -->
              </p>
            </div>

            <div class="clearfix table-type">


              <div class="left-stat-icon">

                <img src="../../../assets/img/globe.png" width="100">


              </div>

              <div class="right-icon-stats">

                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <p class="number pt-0">{{globalInfo?.total_countries}}

                    </p>
                    <p class="total-text ml-2">{{ 'Countries' | translate}}
                    </p>
                  </div>
                  <div class="mt-2">
                    <button class="btn btn-country" data-toggle="modal" data-target="#view-instructions">view
                      Countries</button>
                  </div>
                </div>




              </div>


            </div>





          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3">
          <div class="inner-box ">

            <div class="top-left-ico-text">
              <p class="ico-top-text">PREVIOUS ILO STAGE
                <!-- <span class="white-right">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                    <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                  </svg>
                </span> -->
              </p>
            </div>

            <div class="clearfix table-type soft-hard-box">





              <div class="row bg-row">



                <div class="col some-padding text-centered">
                  <div>
                    <!-- <div>
                      <img src="../../../assets/img/softcap-icon.png" class="softcap-img" alt="softcap-icon">
                    </div> -->

                    <div class="d-flex flex-column justify-content-center mt-3">
                      <p class="ico-top-text mb-1 p-0">Founder</p>
                      <div class="d-flex flex-row justify-content-center mb-0">
                        <p class="number pt-0" *ngIf="noFounder">N/A</p>
                        <div *ngIf="!noFounder">
                          <div class="ico-top-text p-0">
                            Total PIP Issued
                          </div>
                          <div>
                            <p class="number pt-0">{{founderPPTL}}</p>

                            <p class="ml-2 dollar pt-0">PIP</p>
                          </div>

                        </div>
                      </div>
                      <!-- <div class="d-flex flex-row justify-content-center">
                        <p class="number pt-0" *ngIf="noFounder">N/A</p>
                        <p class="number pt-0" *ngIf="!noFounder">{{founderAudValue | currency: 'crypto'}}</p>
                        <p class="ml-2 dollar pt-0">AUD$</p>
                      </div> -->
                      <!-- <p class="number"> {{ICOInformation?.softCap}}
                        <span class="dollar">PPTL</span>
                      </p>
                      <p class="total-text"> {{ 'Softcap' | translate}}
  
                      </p> -->

                    </div>
                  </div>

                </div>


                <!-- <div class="col  text-centered"> -->

                <!-- <div >
                    <img src="../../../assets/img/hardcap-icon.png" class="hardcap-img" alt="softcap-icon">
                  </div> -->
                <!-- <div>
                    <p class="number">{{ICOInformation?.hardCap}}
                      <span class="dollar">PPTL</span>
                    </p>
                    <p class="total-text">{{ 'Hardcap' | translate}}
  
                    </p>
                  </div> -->
                <!-- <div class="d-flex flex-column justify-content-center mt-3">

                    <p class="ico-top-text mb-3 p-0">New Licensees</p>
                      <div class="d-flex flex-row justify-content-center mb-0">
                        <p class="number pt-0">34324</p>
                      </div>
                  </div> -->
                <!-- </div> -->

              </div>



            </div>




          </div>
        </div>



      </div>
    </div>




    <div class="ico-content-div">
      <div class="row row-eq-height" *ngIf="!noPendingStages"
        [ngClass]="{'justify-content-center': hideSecondBox==true}">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 no-right"
          [ngClass]="{'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 right-15': hideSecondBox==true}">
          <div class="genral-sett-div">
            <div class="genral-sett-div-head clearfix width100">
              <div class="leftside clearfix width25" style="width:100%">
                <p class="gnrl-sett-txt">
                  {{ 'CURRENT STAGE' | translate}}
                  <span class="sale-stopped" *ngIf="isSaleStopped">{{'Currently Sale Is Stopped' | translate}}</span>
                </p>
              </div>

            </div>


            <div class="clearfix time-block">

              <div class="time-icon clearfix">
                <img src="../../../assets/img/time-icon.png" alt="time-icon">
              </div>
              <div class="ico-small-head-upper clearfix">
                <p class="till-pIco-Stge-txt stage-padding text-uppercase">
                  {{ICOStageInfoLeft?.stageName | translate}}
                </p>

              </div>

            </div>

            <p class="till-pIco-Stge-small p-top"> PIP Starting Value:
              <strong>{{ICOStageInfoLeft?.stageRate }} (AUD)</strong>
            </p>
            <!-- <p class="till-pIco-Stge-small p-top"> {{ 'REMAINING TOKENS:' | translate}}
               <strong>{{currentICOStageValue}}</strong>

            </p> -->



            <p class="till-pIco-Stge-small p-top" *ngIf="!hideSecondBox">{{'Till' | translate}}
              {{ICOStageInfoRight?.stageName}}</p>
            <p class="till-pIco-Stge-small p-top" *ngIf="hideSecondBox">{{'ICO will end after the current stage' |
              translate}}</p>
            <p class="till-pIco-Stge-small p-top"> Target:
              <!-- <strong>{{ICOStageInfoLeft?.totalSaleAmount - ICOStageInfoLeft?.amountSold | currency}}</strong> -->
              <strong>{{stageLeftData?.target}} <span class="gpal-text">GPALs</span> Registered</strong>

            </p>
            <div class="text-center p-top">
              <!-- <button class="submit-btn" data-toggle="modal"
              data-target="#stage1">Bonuses</button> -->
              <button class="bonus-btn" (click)="invokeInfoModal(ICOStageInfoLeft?.stageName)">View your benefits and
                bonuses</button>
            </div>
            <div class="progress-div fancy-progress p-top">
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"
                  [style.width.%]="leftProgressBar">
                  <span class="sr-only">{{leftProgressBar}}% {{'Complete' | translate}}</span>
                </div>
              </div>
            </div>
            <div>
              <p class="till-pIco-Stge-txt2">
                {{leftProgressBar}}% {{ 'Complete' | translate}}
              </p>
            </div>


            <div class="bottom-columns">

              <ul class="progress-bottom clearfix">
                <li>
                  <p class="top-heading text-uppercase">{{ICOStageInfoLeft?.stageName}} Starting Point:</p>
                  <p class="top-heading text-uppercase">
                    <strong>{{stageLeftData?.startingPoint}} <span class="gpal-text">GPALs</span> </strong>
                  </p>
                </li>
                <li>
                  <p class="top-heading text-uppercase">Total Allocated {{ICOStageInfoLeft?.stageName}} Tokens:</p>
                  <p class="top-heading text-uppercase">
                    <strong>Up to {{ICOStageInfoLeft?.amountSold | currency: 'fait'}}</strong>
                  </p>
                </li>
                <li *ngIf="stageRightData">
                  <p class="top-heading text-uppercase">{{ICOStageInfoRight?.stageName}} Preview :</p>
                  <p class="top-heading text-uppercase">
                    <strong>Starting at {{stageRightData?.startingPoint}} <span class="gpal-text">GPALs</span>
                      PIP Value: {{ICOStageInfoRight?.stageRate}} (AUD)</strong>
                  </p>
                </li>
                <li *ngIf="!stageRightData">
                  <p class="top-heading text-uppercase">{{ICOStageInfoLeft?.stageName}}</p>
                  <p class="top-heading text-uppercase">
                    <strong>
                      PIP Value: {{ICOStageInfoLeft?.stageRate}} (AUD)</strong>
                  </p>
                </li>
              </ul>


            </div>




            <!-- <div class="clock-wrap">
              <ul class="clock-names-ul">
                <li>
                  <p class="days-t">{{ 'DAYS' | translate}}</p>
                </li>
                <li>
                  <p class="days-t">{{ 'HOURS' | translate}}</p>

                </li>
                <li>
                  <p class="days-t">{{ 'MINUTES' | translate}}</p>

                </li>
                <li class="no-rit">
                  <p class="days-t">{{ 'SECONDS' | translate}}</p>

                </li>
              </ul>

              <ul class="clock-ul">
                <li>

                  <p id="days">0</p>
                </li>
                <li>

                  <p id="hrs">9</p>

                </li>
                <li>

                  <p id="mins">45</p>

                </li>
                <li class="no-rit">

                  <p id="sec">39</p>

                </li>
              </ul>
            </div> -->




          </div>
        </div>


        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" [hidden]="hideSecondBox">
          <div class="genral-sett-div">
            <div class="genral-sett-div-head clearfix width100">
              <div class="leftside clearfix width25">
                <p class="gnrl-sett-txt">
                  {{ 'UPCOMING ILO STAGE' | translate}}
                </p>
              </div>
            </div>

            <div class="clearfix time-block-down">
              <div class="ico-small-head" style="padding-top: 5px;">
                <h1 class="till-pIco-Stge-txt text-uppercase"> {{ICOStageInfoRight?.stageName | translate}}</h1>

                <p class="till-pIco-Stge-small p-top"> PIP Starting Value:
                  <strong>{{ICOStageInfoRight?.stageRate}} (AUD)</strong>
                </p>
                <!-- <p class="till-pIco-Stge-small p-top"> {{ 'REMAINING TOKENS:' | translate}}
                   <strong>{{currentICOStageValue}}</strong>
    
                </p> -->
    
    
    
                <p class="till-pIco-Stge-small p-top" *ngIf="!stageRightData?.name == 'ILO Stage 4'">{{'Till' | translate}}
                  {{ICOStageInfoRight?.stageName}}</p>
    
                <p class="till-pIco-Stge-small p-top"> Target:
                  <!-- <strong>{{ICOStageInfoLeft?.totalSaleAmount - ICOStageInfoLeft?.amountSold | currency}}</strong> -->
                  <strong>{{stageRightData?.target}}  <span class="gpal-text">GPALs</span> Registered</strong>
    
                </p>
                <!-- <p class="till-pIco-Stge-small p-top">{{ 'STARTING PRICE:' | translate}}
                  <strong>{{ICOStageInfoRight?.stageRate}}</strong>
                </p> -->
              </div>
            </div>

            <div class="text-center paddingbtn">
              <button class="bonus-btn" (click)="invokeInfoModal(ICOStageInfoRight?.stageName)">View your benefits and
                bonuses</button>
            </div>



            <div class="bottom-columns">

              <ul class="progress-bottom clearfix">
                <li>
                  <p class="top-heading text-uppercase">{{ICOStageInfoRight?.stageName}} Starting Point:</p>
                  <p class="top-heading text-uppercase">
                    <strong>{{stageRightData?.startingPoint}} <span class="gpal-text">GPALs</span> </strong>
                  </p>
                </li>
                <!-- <li>
                  <p class="center-heading text-uppercase">{{ 'TOKEN AMOUNT' | translate}}</p>
                  <p class="big-amount text-uppercase">
                    <strong>{{ICOStageInfoRight?.totalSaleAmount}}</strong>
                  </p>
                </li> -->
                <li>
                  <p class="top-heading text-uppercase">Total Allocated {{ICOStageInfoRight?.stageName}} Tokens:</p>
                  <p class="top-heading text-uppercase">
                    <strong>Up to {{ICOStageInfoRight?.amountSold | currency: 'fait'}}</strong>
                  </p>
                </li>
                <li *ngIf="!stageRightData?.name == 'ILO Stage 4'">
                  <p class="top-heading text-uppercase">{{ICOStageInfoRight?.stageName}} Preview :</p>
                  <p class="top-heading text-uppercase">
                    <strong>Starting at {{stageRightData?.startingPoint}}  <span class="gpal-text">GPALs</span>
                      PIP Value: {{ICOStageInfoRight?.stageRate}} (AUD)</strong>
                  </p>
                </li>
                <li *ngIf="stageRightData?.name == 'ILO Stage 4'">
                  <p class="top-heading text-uppercase">{{ICOStageInfoRight?.stageName}} :</p>
                  <p class="top-heading text-uppercase">
                    <strong> Starting at {{stageRightData?.startingPoint}}  <span class="gpal-text">GPALs</span>
                      PIP Value: {{ICOStageInfoRight?.stageRate}} (AUD)</strong>
                  </p>
                </li>
              </ul>


            </div>








          </div>
        </div>
      </div>

      <div *ngIf="noPendingStages">

        <div class="no-data-box">
          <div class="no-data">
            <p>{{'Token Sale has Ended' | translate}}</p>
          </div>
        </div>

      </div>

      <div class="row stages-row">

        <ul class="stages-progress-horizontal clearfix">


          <li class="responsive-stages" *ngFor="let stage of allICOStages;let i=index" [style.width.%]="stageWidth">
            <p class='stage-name'>{{stage?.StageName | translate}}</p>
            <div class="inner-progresses" [ngClass]='stage.current'>
              <div class="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"
                [style.width.%]="stage.soldPercentage">
                <p class='status'>{{stage.current | translate}}</p>
              </div>
            </div>
            <p class='stage-disc'></p>
            <!-- <p class='stage-disc'> {{ 'Discount' | translate }} {{ stage?.discount }}</p> -->
          </li>

        </ul>

        <!-- <ul class="just-ico">
          <li>
            <p class='stage-name'>After ICO</p>
            <div class="inner-progresses">
              <div class="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"
                style="width:0%">

              </div>

            </div>
          </li>
        </ul> -->

      </div>

      <!-- <div class="row stages-row-bottom">

                <ul class="earn-left-ul">
                    <li>
                        <div class="inner-progresses">
                            <div class="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width:0%">
                                <p class='text'>+ free
                                    <span class='earn-text'>Earn</span> Coins</p>
                            </div>

                        </div>
                    </li>
                </ul>

                <ul class="earn-tokens-ul">
                    <li>
                        <div class="inner-progresses">
                            <div class="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                <p class='text'>+ free
                                    <span class='earn-text'>Earn</span> Coins</p>
                            </div>

                        </div>
                    </li>
                </ul>

            </div> -->


      <div class="row">
        <div class="col-12">
          <div class="table-div">
            <div class="genral-sett-div-head clearfix width100 p-3">
              <div class="leftside">
                <p class="gnrl-sett-txt p-0 mb-0 text-left piptle-font">
                  {{ 'ILO PIPTLERS' | translate}}
                </p>
              </div>
              <!-- <div class="d-flex justify-content-end">
                <button class="btn participation-btn">
                  {{ 'View Participation Ranks' | translate}}
                </button>
              </div> -->

            </div>
            <div class="p-3">
              <div class="topp pt-0">
                <div class="table-responsive no-wrap-640">
                  <table class="table my-tbl table-striped">
                    <thead>
                      <tr>
                        <th>
                          <div class="pos-rltv gap-blw">
                            <p class="tbl-head-txt">Date Issued</p>
                          </div>
                        </th>
                        <th>
                          <div class="pos-rltv gap-blw">
                            <p class="tbl-head-txt">Username</p>
                          </div>
                        </th>
                        <th>
                          <div class="pos-rltv gap-blw">
                            <p class="tbl-head-txt">Country</p>
                          </div>
                        </th>
                        <th>

                          <p class="tbl-head-txt">Pip Cryptos Issued</p>
                        </th>

                        <th class="">
                          <p class="tbl-head-txt">Stage Type</p>
                        </th>
                        <!-- <th class="">
                          <p class="tbl-head-txt centerAlgn">{{ 'PARTICIPATION RANK' | translate }}</p>
                        </th> -->

                        <th>

                          <p class="tbl-head-txt ">Coin Value (AUD)</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="" *ngIf="!pptlLoader && paginationNumber != 0">

                      <tr class="trname" *ngFor="let data of pptlDetails">
                        <td class="td-name">{{data.date | date : 'dd/MM/yyyy'}}</td>

                        <td class="td-name">{{data.userName}}</td>
                        <td class="td-name">{{data.country}} </td>
                        <td class="td-token pl-3">

                          <div class="clearfix">
                            <ul class="token-progress">
                              <li>
                                <span class="font-13">{{data.piptles | currency:'crypto'}}</span>
                                <!-- <strong class="bold-text">PPTL </strong> -->
                              </li>

                            </ul>


                          </div>



                        </td>
                        <td class="td-name">{{data.iloStage}} </td>
                        <!-- <td class="td-name centerAlgn">GPA </td> -->
                        <!-- <td>
                          <div class="progress-table-wrap">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0"
                                aria-valuemax="100" [style.width.%]="investors.percentageSold">

                              </div>
                            </div>
                          </div>
                        </td> -->
                        <td class=" td-total last-td">$ <span class="font-13">{{data.value | currency:'fait'}}</span>
                        </td>
                      </tr>


                    </tbody>


                    <tbody *ngIf="pptlLoader">
                      <tr>
                        <td colspan="12">
                          <div class="custom-loader">
                            <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                              preserveAspectRatio="xMidYMid">
                              <g transform="rotate(208.756 50 50)">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                                  values="360 50 50;0 50 50" keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5"
                                  calcMode="spline">
                                </animateTransform>
                                <path fill="#85ffbd"
                                  d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                </path>
                                <path fill="#316598"
                                  d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                </path>
                                <path fill="#a4bcc2"
                                  d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                </path>
                              </g>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    </tbody>


                  </table>
                  <div *ngIf="!pptlLoader && paginationNumber == 0" class="text-center no-data-found">
                    No Data Found
                  </div>
                  <div class='pagination-bottom pt-2' *ngIf="!pptlLoader && paginationNumber != 0">

                    <pagination-controls *ngIf="referralPSize < paginationNumber" responsive="true" previousLabel=""
                      nextLabel="" (pageChange)="changePageForDetails($event)"></pagination-controls>


                    <ul class="no-visibility-2 d-none">
                      <li
                        *ngFor="let item of pptlDetails | paginate: { itemsPerPage: referralPSize, currentPage: topReferalCurrentPage, totalItems: paginationNumber }">
                        {{item}}
                      </li>
                    </ul>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>


<!-- countries modal -->
<div class="modal" id="view-instructions" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="d-flex justify-content-between align-items-center instruction-close">
        <p class="instruction-txt">Countries</p>
        <img src="../../../assets/img/close.png" alt="close-image" (click)="closeModal()" />
      </div>
      <!-- <div class="close-modal instruction-close" class="close" data-dismiss="modal" (click)="closeModal()"><img src="../../../assets/img/close.png"
                      alt="close-image" /></div> -->
      <div class="modal-body pt-0">

        <hr class="custom-2" />

        <div class="scroll-div">
          <div class="instructions">
            <div class="d-flex">
              <p class="w-50 text-center instructions-text-heading">Country</p>
              <p class="w-50 text-center instructions-text-heading">Registered Users</p>
            </div>
            <div class="d-flex flex-column" *ngFor="let country of allCountries | keyvalue">
              <div class="d-flex ">
                <p class="w-50 text-center instructions-text" *ngIf="country.key.includes('_')">
                  {{country.key.split('_').join(' ').toUpperCase()}}
                </p>
                <p class="w-50 text-center instructions-text" *ngIf="!country.key.includes('_')">
                  {{country.key.toUpperCase()}}
                </p>
                <p class="w-50 text-center instructions-text">{{country.value}}</p>
              </div>
            </div>
          </div>
        </div>



      </div>


    </div>
  </div>
</div>